export const formatNumber = (num) => {
  try {
    const formatted = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    return formatted
  } catch (error) {
    return num
  }
}